import { TabContext, TabPanel } from "@mui/lab";
import { TabLinks } from "components/TabLinks";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useSearchParams } from "react-router-dom";

import { FlagsTab } from "./FlagsTab";
import { OrganizationsTab } from "./OrganizationsTab";

/**
 * Staff Feature Flags page. Two tabs:
 *  - `?tab=flags`         (default) — flag-centric grid (one row per flag)
 *  - `?tab=organizations` — tenant-centric grid (one row per organization)
 *
 * Both tabs preserve their omnisearch query independently via separate
 * persistence keys. Tab routing matches `OrganizationDetails` —
 * `?tab=...` URL parameter, no nested routes.
 */
export function StaffFeatureFlagsPage() {
  useBreadcrumb({ label: "Feature Flags" });
  const [searchParams] = useSearchParams();

  const tabs = [
    {
      title: "Feature Flags",
      to: ".?tab=flags",
      component: <FlagsTab />,
    },
    {
      title: "Organizations",
      to: ".?tab=organizations",
      component: <OrganizationsTab />,
    },
  ];

  const selectedTabVal =
    tabs.find((t) => t.to === `.?tab=${searchParams.get("tab")}`)?.to ?? tabs[0].to;

  return (
    <TabContext value={selectedTabVal}>
      <TabLinks tabs={tabs} value={selectedTabVal} />
      {tabs.map((tab) => (
        <TabPanel key={tab.to} value={tab.to} sx={{ px: 0, py: 3 }}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContext>
  );
}

// Re-export for tests that previously imported from `./index`.
export { computeCurrentStatesAcrossTenants } from "./OrganizationsTab";
